<template>
  <div id="checkout-grid">
    <div v-if="checkinData.items.length > 0">
      <vs-row class="w-full">
          <vs-col class="w-custom flex" v-for="(item, index) in checkinListItems" :key="index">
              <vx-card class="w-full p-5 pt-6 m-4 mx-3 cursor-pointer flex position-relative" @click.native="updateActiveCheckout(item)" v-if="item.customer" :class="{'is-selected': item.check_out.my_status}">
                <!-- <vs-row> -->
                  <!-- <vs-col class="w-1/12 flex align-center">{{index + 1}}</vs-col> -->
                  <!-- <vs-col class="w-11/12"> -->
                  <!-- <div>
                    <h4 class="customer-name font-bold pt-0">{{index + 1}}. {{item.customer.full_name}}</h4>
                    <span class="my-2 block font-bold flex">
                      <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 mr-1" />
                      <h6 class="font-bold">{{StringHelper.phoneNumberFormat(item.customer.phone)}}</h6>
                    </span>
                  </div> -->
                  <feather-icon icon="EditIcon" svgClasses="w-6 h-5 stroke-current text-primary" class="note-icon" v-if="item.customer && item.customer.note && item.customer.note != ''" />
                  <div class="flex flex-col justify-between w-full">
                    <div>
                      <vs-row>
                        <vs-col class="w-8/12">
                          <h4 class="customer-name font-bold pt-0">{{index + 1}}. <span class="edit-from-customer-name" @click.stop="updateCustomer(item)">{{ item.customer.full_name }}</span></h4>
                          <span class="my-2 block font-bold flex">
                            <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 mr-1" />
                            <h6 class="font-bold">{{StringHelper.phoneNumberFormat(item.customer.phone, true)}}</h6>
                          </span>
                          <div class="text-sm">
                            <div class="my-1">
                              Check in:
                              <span class="text-primary position-relative">
                                <span style="position: absolute; top: 0; left: 2px; width: max-content">{{changeFormat(item.create_at)}}</span>
                              </span>
                            </div>
                            <div class="flex" v-if="item.customer && item.customer.last_review && item.customer.last_review.rating">
                              Last reviewed:
                              <star-rating :rating="item.customer.last_review.rating" :read-only="true" :increment="1" class="ml-2" :star-size="12" :show-rating="false"></star-rating>
                            </div>
                            <div class="flex" v-else style="visibility: hidden">
                              Last reviewed:
                              <star-rating :rating="0" :read-only="true" :increment="1" class="ml-2" :star-size="12" :show-rating="false"></star-rating>
                            </div>
                          </div>
                        </vs-col>
                        <vs-col class="w-4/12">
                          <div class="flex flex-col align-center" style="transform: translateX(6px)">
                            <h6 class="font-bold pb-2">{{item.customer.current_point}} Points</h6>
                            <vs-alert :color="getMemberTypeColor(item.customer.type)" class="flex align-center justify-center">{{item.customer.type}}</vs-alert>
                          </div>
                        </vs-col>
                      </vs-row>

                    </div>
                    <div>
                      <vs-row class="mt-4">
                        <vs-col class="w-8/12 flex flex-col justify-end">
                          <div class="text-sm flex" v-if="serviceFeatureActive">
                            <div class="mr-2">Service: </div>
                            <div>
                              <div v-if="item.services && item.services.length > 0">
                                <span v-for="(service, index_service) in getService(item.services)" :key="index_service + 'A' + service_key" class="pr-2 pb-2 d-inline-block">
                                  <!-- <i
                                    class="material-icons cursor-pointer bg-primary text-white user-select-none edit-icon" @click.stop="staffDetail"
                                  >perm_identity</i>-->
                                  <!-- <feather-icon
                                    icon="UserIcon"
                                    svgClasses="h-10 w-10 mr-1 text-white gradient gradient-primary no-shadow rounded-full p-2 material-icons cursor-pointer"
                                    @click.stop="staffDetail(tr)"
                                  /> -->
                                  <!-- Service -->
                                  <!-- <span v-if="index_service < 3"> -->
                                    <span class="px-1 bg-warning rounded text-white d-inline-block break-word text-center" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 150px" @click.stop="changeStatusServiceShowFull(index, index_service)" v-if="!service.show_full">{{getAcronym(service.name)}}</span>
                                    <span class="px-1 bg-warning rounded text-white d-inline-block break-word text-center" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 150px" @click.stop="changeStatusServiceShowFull(index, index_service)" v-if="service.show_full">{{service.name}}</span>
                                  <!-- </span> -->
                                  <!-- <span v-else style="display: none !important"></span> -->
                                </span>
                                  <!-- <span v-if="item.services.length > 3" class="text-2xl" style="line-height: 1">...</span> -->
                              </div>
                              <div v-else class="pb-3">N/A</div>
                            </div>
                          </div>

                          <div class="text-sm flex" v-if="item.groups">
                            <div class="mr-2">Group: </div>
                            <div class="text-primary flex flex-wrap break-word" v-if="item.groups.length > 0">
                              <span class="mr-1" v-for="(group, group_index) in item.groups" :key="group_index">
                                <span v-if="group_index != item.groups.length - 1">{{group.name}}, </span>
                                <span v-else>{{group.name}}</span>
                              </span>
                            </div>
                            <div v-else>N/A</div>
                          </div>
                        </vs-col>
                        <vs-col class="w-4/12"  v-if="config.check_in && config.check_in.signature_active == 1">
                          <div class="h-full flex flex-col align-center justify-around" v-if="item.attachment" @click.stop="openSignaturePopup(item)" style="transform: translateX(6px)">
                            <p class="text-sm">Signed</p>
                            <feather-icon
                            icon="CheckCircleIcon"
                            class="flex align-center justify-center"
                            style="color: #2979FF"
                            ></feather-icon>
                          </div>
                          <div class="h-full flex flex-col align-center justify-around" v-else style="visibility: hidden; transform: translateX(6px)">
                            <p class="text-sm">Signed</p>
                            <feather-icon
                            icon="CheckCircleIcon"
                            class="flex align-center justify-center"
                            style="color: #2979FF"
                            ></feather-icon>
                          </div>
                        </vs-col>
                      </vs-row>
                      <vs-divider class="my-2"></vs-divider>
                      <vs-row>
                        <vs-col class="w-7/12 my-auto text-sm">
                            <div class="flex align-center" v-if="staffFeatureActive" @click.stop="openPopupUpdateStaff(item)">
                              Staff:
                              <div style="width: 200px" v-if="item.staffs && item.staffs.length > 0 || serviceHasStaff(item) == true">
                                <div class="flex flex-wrap items-center flex-grow">
                                  <div class="px-1" v-for="(staff, index_staff) in getService(item.staffs)" :key="index_staff + 'checkin_staff'">
                                    <div class="tooltip" @click.stop="openPopupUpdateStaff(item)">
                                      <vs-button class="tooltip-staff-avatar" @click.stop="openPopupUpdateStaff(item)">
                                        <span class="flex flex-col align-center" style="width: 40px; overflow: hidden;">
                                          <vs-avatar :src="staff.image_url" :color="staff.color_code ? staff.color_code : 'primary'" :text="StringHelper.changeFormatAvatar(staff.name)" size="25px" class="text-md" />
                                          <span class="text-sm" style="max-width: 40px; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap;">{{staff.name}}</span>
                                        </span>
                                      </vs-button>
                                      <span class="tooltiptext" style="word-wrap: break-word; word-break: break-word;">{{staff.name}}</span>
                                    </div>
                                  </div>
                                  <!-- <span v-if="item.staffs.length > 3" class="text-2xl" style="line-height: 1">...</span> -->
                                  <div class="px-1" v-for="(staff, index_staff) in item.customer_checkin_services" :key="index_staff + 'b'">
                                    <div class="tooltip" @click.stop="openPopupUpdateStaff(item)">
                                      <vs-button class="tooltip-staff-avatar" @click.stop="openPopupUpdateStaff(item)">
                                        <span class="flex flex-col align-center" style="width: 40px; overflow: hidden;" v-if="staff && staff.staff && checkExistedStaff(staff.staff, item.staffs, item.customer_checkin_services, index_staff)">
                                          <vs-avatar :src="staff.staff.image_url" :color="staff.staff.color_code ? staff.staff.color_code : 'primary'" :text="StringHelper.changeFormatAvatar(staff.staff.name)" size="25px" class="text-md" />
                                          <span class="text-sm" style="max-width: 40px; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap;">{{staff.staff.name}}</span>
                                        </span>
                                      </vs-button>
                                      <span class="tooltiptext" style="word-wrap: break-word; word-break: break-word;" v-if="staff && staff.staff">{{staff.staff.name}}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div v-else class="ml-2">N/A</div>
                            </div>
                        </vs-col>
                        <vs-col class="w-5/12 flex justify-center">
                            <div class="flex flex-col align-center justify-center" style="transform: translateX(6px)">
                                <!-- <label class="text-xs mb-2">Staff & service</label>
                                <feather-icon icon="UserIcon" svgClasses="h-10 w-10 mr-1 text-white gradient gradient-primary no-shadow rounded-full p-2 material-icons cursor-pointer"
                                @click.stop="staffDetail(item)"/> -->

                              <label class="text-sm mb-2">In service</label>
                              <div class="in-service-switch">
                                <vs-switch v-model="item.check_out.my_status" v-on:click.stop="changeStatusInService(item)" />
                              </div>
                            </div>
                            <div class="flex flex-col align-center justify-center" style="transform: translateX(6px)" v-if="show_send_sms_to_waiting_customer">
                              <label class="text-sm mb-2">SMS</label>
                              <div class="in-service-switch">
                                <vs-switch :value="true" v-on:click.stop="alertNoSendSMSPermission" v-if="item.check_out.sms_sent == 2" />
                                <vs-switch :value="true" v-on:click.stop="changeStatusSMSSent(item)" v-if="item.check_out.sms_sent == 1" />
                                <vs-switch :value="false" v-on:click.stop="changeStatusSMSSent(item)" v-if="item.check_out.sms_sent == 0" />
                              </div>
                            </div>
                        </vs-col>
                      </vs-row>
                    </div>
                  </div>

                  <!-- </vs-col> -->
                <!-- </vs-row> -->
              </vx-card>
          </vs-col>
      </vs-row>
      <!-- <div v-if="checkinData._meta.pageCount > 1">
        <vs-pagination class="custom-pagination" :total="checkinData._meta.pageCount" v-model="currentPage" @click.native="changePage(currentPage, itemsPerPage)"></vs-pagination>
      </div> -->

      <popup-update-staff :popupUpdateStaffConfig="popupUpdateStaffConfig" :key="'grid-update-staff-' + update_staff_key" @UpdateCustomerCheckinStaff="updateCustomerCheckinStaff"></popup-update-staff>

      <!-- <vs-popup-staff-service-detail :popupStaffDetail="popupStaffDetail" :key="test"></vs-popup-staff-service-detail> -->
        <signature-popup :popupConfig="popupSignature" :key="signatureKey + 'grid'"></signature-popup>
        <vs-popup-info-new-ver :popupConfigNew="popupConfigNew" :search="search" :sort_by="sort_by" :filter="filter" :key="'new-ver' + abc" @UpdateNote="getCheckinList"></vs-popup-info-new-ver>
        <vs-auto-checkout-popup :popupConfigNew="popupConfig" :search="search" :filter="filter" :sort_by="sort_by" :key="'auto' + abc" @UpdateNote="getCheckinList"></vs-auto-checkout-popup>
    </div>
    <div class="text-center mt-base" v-else>No data available</div>
    <customer-popup-content v-if="customer_key != 0" :popupConfig="popupCustomerConfig" :activeCustomer="activeCustomer" :checkoutFilter="checkoutFilter" :key="customer_key + 'b'" @ClosePopup="popupCustomerConfig.isOpen = false" :isFromCheckout="true"></customer-popup-content>
  </div>
</template>

<script>
// import moment from 'moment';
import { StringHelper } from '../../models/string_helper'
import {changeFormatWithDateTime} from '../../helper/datetimeHelper';
import StarRating from "vue-star-rating";
export default {
  name: "vs-checkout-grid",
  components: {
    StarRating
  },
  props: {
    //   popupConfig: {
    //       type: Object
    //   },
      // check_in_data: {
      //     type: Array
      // },
      // currentPage: {
      //     type: Number
      // },
      // itemsPerPage: {
      //     type: Number
      // },
      new_ver: {
        type: Boolean
      },
      // checkinData: {
      //   type: Object,
      //   required: true
      // }
      search: {
        type: String
      },
      filter: {
        type: Object
      },
      sort_by: {
        type: Object
      }
  },
  data() {
    return {
        StringHelper,
        // itemInfo: {},
        temp: true,
        popupStaffDetail: {
          isOpen: false,
          item_info: {}
        },
        popupConfig: {
            isOpen: false,
            item_info: {}
        },
        popupConfigNew: {
            isOpen: false,
            item_info: {}
        },
        popupCustomerConfig: {
          isOpen: false
        },
        popupUpdateStaffConfig: {
          isOpen: false,
          item_info: null
        },
        update_staff_key: 0,
        // currentPage: 1,
        // itemsPerPage: 6,
        test:0,
        service_key: 0,
        abc: 0,
        action_type: '',
        isOpenLoading: false,
        activeCustomer: {},
        customer_key: 0,
        type: '',
        popupSignature: {
             title: "Signature",
             isOpen: false,
             attachment: null
        },
        signatureKey: 50000,
        checkoutFilter: {
          keyword: '',
          type: '',
          sort: ''
        }
    };
  },
  watch: {
    checkinData: {
      immediate: true,
      deep: true,
      handler() {
        // checkinData.items
        if (
          this.checkinData &&
          this.checkinData.items.length != 0 &&
          this.popupConfigNew.item_info.id
        ) {
          for (let i = 0; i < this.checkinData.items.length; i++) {
            if (
              this.checkinData.items[i].id == this.popupConfigNew.item_info.id
            ) {
              this.popupConfigNew.item_info = this.checkinData.items[i];
              break;
            }
          }
        }
      }
    },
    filter: {
      immediate: true,
      deep: true,
      handler() {
        if (this.filter && this.filter.id != 1) {
          this.checkoutFilter.type = this.filter.name;
        } else {
          this.checkoutFilter.type = '';
        }
        this.getCheckinList();
      }
    },
    search: {
      immediate: true,
      deep: true,
      handler() {
        this.checkoutFilter.keyword = this.search;
        this.getCheckinList();
      }
    },
    sort_by: {
      immediate: true,
      deep: true,
      handler() {
        if(this.sort_by && this.sort_by.id == 2) {
          this.checkoutFilter.sort = this.sort_by.name;
        } else {
          this.checkoutFilter.sort = '';
        }
        this.getCheckinList();
      }
    }
  },
  computed: {
    checkinListItems() {
      return this.$store.getters['checkin/checkinListItems'];
    },
    checkinData() {
      return this.$store.getters['checkin/checkinList'];
    },
    serviceFeatureActive() {
      return this.$store.getters["auth/config"].service_feature;
    },
    staffFeatureActive() {
      return this.$store.getters["auth/config"].staff_feature;
    },
    productFeatureActive() {
      return this.$store.getters["auth/config"].product_feature;
    },
    show_send_sms_to_waiting_customer() {
      return this.$store.getters["auth/config"].show_send_sms_to_waiting_customer;
    },
    config() {
      return this.$store.getters["auth/config"];
    }
  },
  methods: {
    openPopupUpdateStaff(item) {
      if(item) {
        this.popupUpdateStaffConfig.item_info = item;
        this.popupUpdateStaffConfig.isOpen = true;
        this.update_staff_key++;
      }
    },
    updateCustomerCheckinStaff(obj) {
      if(obj) {
        if(!this.isOpenLoading) {
          this.openLoadingInDiv();
        }
        this.action_type = "Update customer checkin staff";
        this.$store.dispatch('checkin/UPDATE_CUSTOMER_CHECKIN_STAFF', obj).then(() => {
          this.closeLoading();
          this.popupUpdateStaffConfig.isOpen = false;
          this.$vs.notify({
            title: "Notification",
            text: "Update customer checkin staff success",
            color: "success",
            position: "top-right"
          });
          this.getCheckinList();
        }).catch((err) => {
          this.closeLoading();
          this.popupUpdateStaffConfig.isOpen = false;
          this.$vs.notify({
            title: "Notification",
            text: "Update customer checkin staff failed",
            color: "danger",
            position: "top-right"
          });
          console.log('Error: ', err);
        })
      }
    },
    checkExistedStaff(staff, checkin_staff_list, customer_checkin_services, customer_checkin_services_index) {
      if(staff && checkin_staff_list && checkin_staff_list.length > 0) {
        let list = checkin_staff_list;
        for(let i = 0; i < list.length; i++) {
          if(list[i].user_id == staff.user_id) {
            return false;
          }
        }
      }
      if(customer_checkin_services && customer_checkin_services.length > 0) {
        let customer_list = customer_checkin_services;
        for(let j = 0; j < customer_checkin_services_index; j++) {
          if(customer_list[j].staff && customer_list[j].staff.user_id == staff.user_id) {
            return false;
          }
        }
      }
      return true;
    },
    serviceHasStaff(data) {
      if(data && data.customer_checkin_services) {
        for(let i = 0; i < data.customer_checkin_services.length; i++) {
          if(data.customer_checkin_services[i].staff) {
            return true;
          }
        }
      }
      return false;
    },
    updateCustomer(item) {
      if(item && item.customer && item.customer_point) {
        let customer = {
          id: item.customer.id,
          full_name: item.customer.full_name,
          type: item.customer.type,
          visit_count: item.customer.visit_count,
          last_visited: item.customer.last_visited,
          lifetime_point: item.customer_point.lifetime_point,
          current_point: item.customer_point.point,
          is_send_sms: item.customer.is_send_sms,
          email: item.customer.email,
          create_at: item.customer_point.created_at,
          phone: item.customer.phone
        }
        this.activeCustomer = customer;
        this.popupCustomerConfig.isOpen = true;
        this.customer_key++;
      }
    },
    getService(services) {
      // let temp = [];
      // for(let i = 0; i < services.length; i++) {
      //   temp.push(services[i]);
      //   if(i == 2) {
      //     break;
      //   }
      // }
      // return temp;
      return services;
    },
    getAcronym(name) {
      let arr_word = name.split(' ');
      let str = '';
      for(let i = 0; i < arr_word.length; i++) {
        str += arr_word[i].charAt(0).toUpperCase();
        if(i == 3) {
          break;
        }
      }
      if(str[str.length - 1] == '$') {
        str = str.substring(0, str.length - 1);
      }
      return str;
    },
    changeStatusServiceShowFull(checkin_index, service_index) {
      this.checkinListItems[checkin_index].services[service_index].show_full = !this.checkinListItems[checkin_index].services[service_index].show_full;
      this.service_key++;
    },
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);
      this.isOpenLoading = true;
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: this.action_type + ' failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' failed',
            acceptText: 'OK'
          })
        }
      }, 10000);

    },
    closeLoading() {
      this.isOpenLoading = false;
      setTimeout(() => {

        this.$vs.loading.close('#app > .con-vs-loading');
      }, 100);
    },
    changeStatusInService(tr) {
      // console.log(tr);
      const obj = {
        checkout_id: tr.check_out.id,
        status: tr.check_out.status == 'pending' ? 'inservice' : 'pending',
        // page: this.currentPage,
        // 'per-page': this.itemsPerPage
      }
      this.action_type = 'Update in service status';
      this.openLoadingInDiv();
      this.$store.dispatch('checkin/UPDATE_IN_SERVICE_STATUS', obj).then(() => {
        this.closeLoading();
      }).catch(() => {
        this.closeLoading();
      });
    },
    alertNoSendSMSPermission() {
      this.$vs.dialog({
        color: "danger",
        title: `Information!`,
        type: "alert",
        text: "This customer has been sent SMS twice!! You're not allowed to do this!!",
        acceptText: 'OK',
        accept: () => {},
      })
    },
    changeStatusSMSSent(tr) {
      if(tr) {
        this.$vs.dialog({
          color: "warning",
          title: `Confirmation!`,
          type: "confirm",
          text: `Do you want to ${tr.check_out.sms_sent == 0 ? 'send' : 'resend'} SMS to this customer?`,
          accept: async () => {
            const obj = {
              checkout_id: tr.check_out.id,
              sms_sent: tr.check_out.sms_sent == 0 ? 1 : 2
            };
  
            this.action_type = "Update SMS sent";
            this.openLoadingInDiv();
            this.$store.dispatch("checkin/UPDATE_SMS_SENT", obj).then(() => {
              this.closeLoading();
              this.$vs.notify({
                title: "Notification",
                text: `Send SMS Success`,
                color: "success",
                position: "top-right",
              });
            }).catch(() => {
              this.closeLoading();
              this.$vs.notify({
                title: "Notification",
                text: `Send SMS Failed`,
                color: "danger",
                position: "top-right",
              });
            });
          },
          cancel: () => {},
        });
      }
    },
    getCheckinList() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.$vs.loading({
        container: "#app",
        scale: 0.8
      });
      this.timer = setTimeout(() => {
        const obj = {
          keyword: this.search
        };
        if(this.filter.id != 1) {
          obj.type = this.filter.name;
        }
        if(this.sort_by.id == 2) {
          obj.sort = this.sort_by.name;
        }
        this.$store.dispatch('checkin/GET_CHECKIN_LIST', obj).then(()=> {
          this.$vs.loading.close("#app > .con-vs-loading");
        });
      }, 500);
      // this.openLoadingInDiv();
      // const obj = {
      //   // page: this.currentPage,
      //   // "per-page": this.itemsPerPage,
      //   "keyword": this.search,
      // }
      // if(this.filter.id != 1) {
      //   obj.type = this.filter.name;
      // }
      // this.$store.dispatch('checkin/GET_CHECKIN_LIST', obj).then(() => {
      //   this.closeLoading();
      // });
    },
    // changePage() {
    //   const obj = {
    //     // page: currentPage,
    //     // "per-page": itemsPerPage,
    //     "keyword": this.search,
    //   }
    //   if(this.filter.id != 1) {
    //     obj.type = this.filter.name;
    //   }
    //   this.$store.dispatch('checkin/GET_CHECKIN_LIST', obj);
    // },
    getGroupString(groups) {
      let str = '';
      for(let i = 0; i < groups.length; i++) {
        str += groups[i].name;
        if(i + 1 != groups.length) {
          str += ', ';
        }
      }
      return str;
    },
    staffDetail(item){
      this.popupStaffDetail.isOpen = true;
      this.popupStaffDetail.item_info = item;
      this.test++;
    },
    updateActiveCheckout(item) {
        // this.$router.push({name:'checkout-detail', params:{itemInfo: item}});
        if(this.type == 'auto') {
          this.popupConfig.isOpen = true;
        } else {
          this.popupConfigNew.isOpen = true;
        }
        this.popupConfig.item_info = item;
        this.popupConfigNew.item_info = item;
        this.abc++;
    },
    changeFormat(day){
      if(day) {
        return changeFormatWithDateTime(day);
      } else {
        return 'N/A';
      }
    },
    getMemberTypeColor(member_type) {
      if (member_type == "new") return "success";
      if (member_type == "regular") return "primary";
      if (member_type == "atrisk") return "warning";
      if (member_type == "vip") return "danger";
      return "purple";
    },
    openSignaturePopup(data) {
      if (data.attachment != null) {
        this.signatureKey++;
        this.popupSignature.attachment = data.attachment;
        this.popupSignature.title = data.customer.full_name
          ? data.customer.full_name
          : "Signature";
        this.popupSignature.isOpen = true;
      }
    }
  },
  created() {
    // const obj = {
    //     // page: this.currentPage,
    //     // "per-page": this.itemsPerPage,
    //     "keyword": this.search,
    //   }
    // this.$store.dispatch('checkin/GET_CHECKIN_LIST', obj);
    this.$store.dispatch("appSetting/GET_CHECKOUT_CONFIG").then(() => {
      let data = {};
      data = this.$store.state.appSetting.checkoutConfig;
      this.type = data.type;
    })
    this.$emit('ChangeView');
  }
  // watch:{
  //   popupConfig: {
  //     immediate: true,
  //     deep: true,
  //     handler() {
  //       if(this.popupConfig.isOpen) {
  //         document.body.classList.add('overflow-hidden');
  //       } else {
  //         document.body.classList.remove('overflow-hidden');
  //       }
  //     }
  //   },
  //   popupConfigNew: {
  //     immediate: true,
  //     deep: true,
  //     handler() {
  //       if(this.popupConfigNew.isOpen) {
  //         document.body.classList.add('overflow-hidden');
  //       } else {
  //         document.body.classList.remove('overflow-hidden');
  //       }
  //     }
  //   }
  // }
};
</script>
